import React, { useState } from "react"
import { useUserContext } from "pages/provider-finder/context/UserContext"
import {
  ProviderFinderParam,
  RedirectToProviderFinderURL,
  getProviderFinderSearchURL
} from "pages/provider-finder/utils/providerFinderSearchUrl"
import { useHistory } from "react-router"
import { KeywordAutocomplete } from "../keyword-search/KeywordAutocomplete"
import { RightIcon } from "@carrotfertility/carotene-core"

export function SidebarKeywordSearch({ keyword }: { keyword: string }): JSX.Element {
  const [providerNameValue, setProviderNameValue] = useState(null)
  const [newURL, setNewURL] = useState(null)

  const { companyCountryCode } = useUserContext()
  const history = useHistory()
  const params = new URLSearchParams(history.location.search)
  const radiusInKm = params.get(ProviderFinderParam.RadiusInKm)
  const carrotPartner = params.get(ProviderFinderParam.CarrotPartner) === "true"
  const providerType = params.get(ProviderFinderParam.ProviderType)

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setProviderNameValue(providerNameValue)
    const newSearchURL = providerNameValue
      ? getProviderFinderSearchURL({
          searchLocation: params.get(ProviderFinderParam.Search),
          locationDetails: {
            latitude: Number(params.get(ProviderFinderParam.Latitude)),
            longitude: Number(params.get(ProviderFinderParam.Longitude)),
            countryCode: params.get(ProviderFinderParam.Country),
            isBroadArea: false
          },
          radiusInKm,
          companyCountryCode,
          carrotPartner,
          providerType,
          keyword: providerNameValue
        })
      : null
    setNewURL(newSearchURL)
  }
  return (
    <>
      <RedirectToProviderFinderURL url={newURL} />

      <form onSubmit={handleSubmit}>
        <KeywordAutocomplete
          keyword={keyword}
          popupIcon={
            <RightIcon
              fontSize="medium"
              sx={(theme) => ({
                marginLeft: theme.spacing(theme.tokens.spacing.xxs),
                marginRight: theme.spacing(theme.tokens.spacing.xxs)
              })}
              onClick={handleSubmit}
            />
          }
          startAdornment={null}
          setProviderNameValue={setProviderNameValue}
          sx={{
            ".MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent"
            },
            "& .MuiAutocomplete-popupIndicator": { transform: "none" }
          }}
        />
      </form>
    </>
  )
}
